import { Link } from "react-router-dom";
import useUserInfo from "../../hooks/useUserInfo";
import ButtonLoader from "../../Loader/student/ButtonLoader";
import { useGetQuizAndMarkQuery } from "../../redux/features/quiz/quizApi";


export default function QuizButtonInPlayer({ videoId }) {
  const user = useUserInfo();
  const { data, isLoading, isError } = useGetQuizAndMarkQuery({ videoId, studentId: user?.id })

  let content = null;
  if (isLoading) { content = <ButtonLoader /> }
  if (!isLoading && isError) { content = null; }
  if (!isLoading && !isError && data?.isQuiz) {
    const { isQuizMark } = data;
    content = <Link to={`/courses/quiz/${videoId}`}
      className={`px-3 font-bold py-1 border  ${isQuizMark ? "bg-gradient-to-r from-cyan-500 to-blue-500 text-primary" : "border-cyan text-cyan"}  rounded-full text-sm hover:bg-cyan hover:text-primary`}>
      {isQuizMark ? "কুইজ মার্ক দেখুন" : "কুইজে অংশগ্রহণ করুন"}
    </Link>
  } else {
    content =
      <button className="px-3 font-bold py-1 border border-cyan text-cyan  rounded-full text-sm">
        কুইজ নেই
      </button>
  }
  return content
};